if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			loadProductFirst: false,
          	filterTreeMobileStyle: 'style1',
            paginationType: 'default',
		}
	};
}

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [200,300,400,500,600,700,800,900,1000,1100,1200];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
      
		// Add Custom class
		var soldOutClass = soldOut ? 'product-item--sold-out' : '';
      	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
      
      	var reveal = boostPFSThemeConfig.custom.reveal ? 'reveal' : '';
      	itemHtml = itemHtml.replace(/{{reveal}}/g, reveal);
      
      	var itemHoverClass = '';
      	if (boostPFSThemeConfig.custom.show_secondary_image && images.length > 1) {
          itemHoverClass = 'product-item__image-wrapper--multiple';
        }
      	itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, itemHoverClass);
      
      	// Add Labels
      	var itemLabels = '';
      	var itemLabelsHtml = '';
      	if (data.tags) {
          var tags = data.tags.filter(function(e){return e.indexOf('__label') > -1});
          if (typeof tags != 'undefined') {
            for (var i = 0; i < tags.length; i++) {
              var tag = tags[i];
              var index = i > 0 ? i + 1 : '';
              itemLabelsHtml += '<span class="label label--custom' + index + '">' + tag.split(':').slice(-1) + '</span>';
            }
            
          }
        }
      	if (soldOut) {
          itemLabelsHtml += '<span class="label label--subdued badge-agotado">' + boostPFSThemeConfig.label.sold_out + '</span>';
        }
      	if (boostPFSThemeConfig.custom.show_discount && onSale && !soldOut) {
          var savings = '';
          if (boostPFSThemeConfig.custom.discount_mode == 'percentage') {
            savings = data.percent_sale_min + '%';
          } else {
            savings = Utils.formatMoney(data.compare_at_price_min - data.price_min);
          }
          itemLabelsHtml += '<span class="label label--highlight">' + data.percent_sale_min + ' % OFF</span>';
        }
      	if (itemLabelsHtml != '') {
          itemLabels += '<div class="product-item__label-list label-list">' + itemLabelsHtml + '</div>';
        }
      	itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabels);
      
      	// Add Images
      	var itemImagesHtml = buildImages(data);
      	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
      
      	// Add Add to Cart Button
      	var itemActionsHtml = buildAddToCartBtn(data);
      	itemHtml = itemHtml.replace(/{{itemActions}}/g, itemActionsHtml);
      
      	// Add Vendor
      	var itemVendor = '';
      	if (boostPFSThemeConfig.custom.show_vendor) {
          var handle = Utils.slugify(data.vendor);
          var collection = data.collections.find(function(e){return e.handle == handle});
          if (typeof collection != 'undefined') {
            itemVendor += '<a class="product-item-meta__vendor heading heading--xsmall" href="/collections/' + collection.handle + '">' + data.vendor + '</a>'
          } else {
            itemVendor += '<a class="product-item-meta__vendor heading heading--xsmall" href="/collections/vendors?q=' + data.vendor + '">' + data.vendor + '</a>'
          }          
        }
      	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);
      
      	// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buidlPrice(data));
      
      	// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
      
      	// Add Color Swatch
      	itemHtml = itemHtml.replace(/{{itemColors}}/g, buidlColorsSwatch(data));
      
		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data, false));
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildImages(data) {      
      var html = '';
      var aspectRatio = 1.0;
      // added if condition to fix some collections not rendering
      // console.log(images)
      if(!images[0] ) return ''
        
      aspectRatio = parseFloat(images[0]['width'] / images[0]['height']);
        
      
  
      html += '<a href="{{itemUrl}}" class="product-item__aspect-ratio aspect-ratio ' + (boostPFSThemeConfig.custom.product_image_size != 'natural' ? 'aspect-ratio--' + boostPFSThemeConfig.custom.product_image_size : '') + '" style="padding-bottom: ' + (100/aspectRatio) + '%; --aspect-ratio: ' + aspectRatio + '">';
      html += '<img class="product-item__primary-image" ' + 
                'loading="lazy" ' + 
                'data-media-id="' + Utils.escape(images[0]['id']) + '" ' + 
                'sizes="' + boostPFSThemeConfig.custom.sizes_attribute + '"' +
                'height="' + images[0]['height'] + '" ' + 
                'width="' + images[0]['width'] + '" ' + 
                'alt="' + Utils.escape(images[0]['alt']) + '" ' + 
                'src="' + Utils.optimizeImage(images[0].src, '1200x') +'" ' + 
                'srcset="' + buildBgSet(images[0].src) + '"' +
              '>';
      if (boostPFSThemeConfig.custom.product_color_display == 'swatch') {
        var variantImages = data.variants.map(function(e){return e.image});
        if (variantImages.length > 0) {
          for (var i = 0; i < variantImages.length; i++) {
            var variantImg = variantImages[i];
            if (variantImg != null) {
              var index = images.findIndex(function(e){return e.src == variantImg});
              html += '<img class="product-item__primary-image" hidden ' + 
                  'loading="lazy" ' + 
                  'data-media-id="' + Utils.escape(images[index]['id']) + '" ' + 
                  'sizes="' + boostPFSThemeConfig.custom.sizes_attribute + '"' +
                  'height="' + images[index]['height'] + '" ' + 
                  'width="' + images[index]['width'] + '" ' + 
                  'alt="' + Utils.escape(images[index]['alt']) + '" ' + 
                  'src="' + Utils.optimizeImage(images[index].src, '1200x') +'" ' + 
                  'srcset="' + buildBgSet(images[index].src) + '"' +
                '>';
            }
            
          }
        }
      }
      if (boostPFSThemeConfig.custom.show_secondary_image && images.length > 1) {
        html += '<img class="product-item__secondary-image" ' + 
                  'loading="lazy" ' + 
                  'data-media-id="' + Utils.escape(images[1]['id']) + '" ' + 
                  'sizes="' + boostPFSThemeConfig.custom.sizes_attribute + '"' +
                  'height="' + images[1]['height'] + '" ' + 
                  'width="' + images[1]['width'] + '" ' + 
                  'alt="' + Utils.escape(images[1]['alt']) + '" ' + 
                  'src="' + Utils.optimizeImage(images[1].src, '1200x') +'" ' + 
                  'srcset="' + buildBgSet(images[1].src) + '"' +
                '>';
      }
      html += '</a>';
      return html;
    }
  
    function buildBgSet(image) {
      var html = '';
      if (typeof image !== 'undefined') {
        for (var i = 0; i < boostPFSRangeWidths.length; i++) {
          var size = boostPFSRangeWidths[i] + 'x';
          html += Utils.optimizeImage(image, size) + ' ' + boostPFSRangeWidths[i] + 'w, ';
        }
      }
      return html;
    }
  
  	function buildAddToCartBtn(data) {
      var html = '';

      const labelButton = () => {
        if (data.variants.length == 1){
          return "Comprar"
        }
        else{
          return "Ver opciones"
        }
      }

      if (data.available && boostPFSThemeConfig.custom.product_add_to_cart) {
        if (data.variants.length == 1) {
          const form_id = `product_form_${boostPFSThemeConfig.custom.template_id}_${data.id}`
          html = `
            <form method="post" action="/cart/add" id="${form_id}" accept-charset="UTF-8" class="product-item__quick-form" enctype="multipart/form-data" is="product-form" data-hs-cf-bound="true">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="quantity" value="1">
              <input type="hidden" name="id" value="${firstVariant.id}">
    
              <button is="loader-button" type="submit" class="button button--outline button--text button--full  hidden-touch">
                <span class="loader-button__text">${labelButton()}</span>
                <span class="loader-button__loader" hidden="">
                  <div class="spinner">
                    <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                      <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                    </svg>
                  </div>
                </span>
              </button>
  
              <button type="submit" class="product-item__quick-buy-button hidden-no-touch">
                <span class="visually-hidden">${labelButton()}</span>
                <svg focusable="false" width="22" height="21" class="icon icon--quick-buy" fill="none" viewBox="0 0 22 21">
                  <path d="M12 4H3L2 20H18C17.7517 16.0273 17.375 10 17.375 10" stroke="currentColor" stroke-width="2"></path>
                  <path d="M7 7V7C7 8.65685 8.34315 10 10 10V10C11.6569 10 13 8.65685 13 7V7" stroke="currentColor" stroke-width="2"></path>
                  <path d="M18 0V8M14 4H22" stroke="currentColor" stroke-width="2"></path>
                </svg>
              </button>
            
              <input type="hidden" name="product-id" value="${data.id}">
              <input type="hidden" name="section-id" value="${boostPFSThemeConfig.custom.section_id}">
            </form>
    
          `
        } else {
          var cart_icon = '<svg ffocusable="false" width="24" height="24" class="icon icon--quick-buy-tote-bag   " fill="none" viewBox="0 0 24 24">' +
                              '<path d="M14 20H4L5 9H19L19.4545 14" stroke="currentColor" stroke-width="1"></path>' +
                              '<path d="M20 16V24M16 20H24" stroke="currentColor" stroke-width="1"></path>' +
                              '<path d="M15 6V6C15 4.34315 13.6569 3 12 3V3C10.3431 3 9 4.34315 9 6V6" stroke="currentColor" stroke-width="1"></path>' +
                            '</svg>';
          html += '<div class="product-item__quick-form">';


          html += '<button is="toggle-button" loader aria-controls="product-' + boostPFSThemeConfig.custom.template_id + '-{{itemId}}-drawer" aria-expanded="false" class="button button--outline button--text button--full hidden-touch hidden-phone">' + labelButton() + '</button>';

          html += '<button is="toggle-button" aria-controls="product-' + boostPFSThemeConfig.custom.template_id + '-{{itemId}}-drawer" aria-expanded="false" class="product-item__quick-buy-button hidden-no-touch hidden-phone">';
          html += '<span class="visually-hidden">' + labelButton() + '</span>';
          html += cart_icon;
          html += '</button>';

          html += '<button is="toggle-button" aria-controls="product-' + boostPFSThemeConfig.custom.template_id + '-{{itemId}}-popover" aria-expanded="false" class="product-item__quick-buy-button hidden-tablet-and-up">';
          html += '<span class="visually-hidden">' + labelButton() + '</span>';
          html += cart_icon;
          html += '</button>';
          
          html += '</div>';

          html += '<quick-buy-popover id="product-' + boostPFSThemeConfig.custom.template_id + '-{{itemId}}-popover" href="{{itemUrl}}?view=quick-buy-popover" class="popover popover--quick-buy hidden-tablet-and-up"></quick-buy-popover>';
          html += '<quick-buy-drawer id="product-' + boostPFSThemeConfig.custom.template_id + '-{{itemId}}-drawer" href="{{itemUrl}}?view=quick-buy-drawer" class="drawer drawer--large drawer--quick-buy hidden-phone"></quick-buy-drawer>';
        }
      }
      return html;
    }
  
  	function buidlPrice(data) {
      var html = '';
      var moneyFormat = (boostPFSThemeConfig.custom.currency_code_enabled) ? 'money_with_currency' : Globals.moneyFormat;
      html += '<div class="product-item-meta__price-list-container">';
      html += '<div class="price-list price-list--centered">';
      if (onSale) {
        if (priceVaries) {
          html += '<span class="price price--highlight">';
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
          html += boostPFSThemeConfig.label.from_price_html.replace('{{ price_min }}', Utils.formatMoney(data.price_min, moneyFormat));
          html += '</span>';

          html += '<span class="price price--compare">';
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
          html += Utils.formatMoney(data.compare_at_price_min, moneyFormat);
          html += '</span>';
        } else {
          html += '<span class="price price--highlight">';
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
          html += Utils.formatMoney(data.price_min, moneyFormat);
          html += '</span>';

          html += '<span class="price price--compare">';
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
          html += Utils.formatMoney(data.compare_at_price_min, moneyFormat);
          html += '</span>';
        }
      } else {
        if (priceVaries) {
          html += '<span class="price">';
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
          html += boostPFSThemeConfig.label.from_price_html.replace('{{ price_min }}', Utils.formatMoney(data.price_min, moneyFormat));
          html += '</span>';
        } else {
          html += '<span class="price">';
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
          html += Utils.formatMoney(data.price_min, moneyFormat);
          html += '</span>';
        }
      }
      html += '</div>';
      html += '</div>';
      return html;
    }
  
  	function buidlColorsSwatch (data) {
      var html = '';
      var option = data.options_with_values.find(function(e){return boostPFSThemeConfig.custom.color_label_list.indexOf(e.name) > -1})
      if (typeof option != 'undefined') {
        if (boostPFSThemeConfig.custom.product_color_display == 'count') {
          var text = (option.values.length == 1) ? boostPFSThemeConfig.label.available_colors_count_one : boostPFSThemeConfig.label.available_colors_count_other;
          html += '<p class="product-item-meta__color-count text--small text--subdued">' + text.replace('{{ count }}', option.values.length) + '</p>';
        } else if (boostPFSThemeConfig.custom.product_color_display == 'swatch') {
          html += '<div class="product-item-meta__swatch-list color-swatch-list color-swatch-list--mini">';
          var swatchLimit = 7;
          if(swatchLimit > option.values.length){
             swatchLimit = option.values.length
          }
          var countShow = 0;
          var extras = 0;
          for (var i = 0; i < option.values.length; i++) {
            var color = option.values[i].title;
            var colorClass = (color.toLowerCase() == boostPFSThemeConfig.custom.color_white_label) ? 'color-swatch--white' : '';
            var variant = data.variants.find(function(e){return e['option_' + option.name] == color});
            if (variant.available && countShow < swatchLimit){
              countShow++;
              var variantImageId = (variant.image) ? (data.images_info.find(function(e){return e.src == variant.image})['id']) : '';
              var colorSwatchStyle = 'background-color: ' + color.toLowerCase();
              var setting = boostPFSThemeConfig.custom.color_swatch_config.find(function(e){return e.split(':')[0].toLowerCase() == color.toLowerCase()});
              
              if (typeof setting != 'undefined') {
                	var colorSwatchSetting = setting.split(':').slice(-1);
                	if (colorSwatchSetting.indexOf('#') > -1) {
                    colorSwatchStyle = 'background-color: ' + colorSwatchSetting;
                  } else {
                    var filename = color.toLowerCase() + '_72x72.png?';
                    colorSwatchStyle = 'background-image: url(\'' + boostPFSAppConfig.general.file_url.replace('?', filename) + '\')'
                  }
              }
              var filename = color.toLowerCase() + '_75x75.png?';
                  colorSwatchStyle = 'background-image: url(\'' + boostPFSAppConfig.general.file_url.replace('?', filename) + '\')'
              html += '<div class="color-swatch ' + colorClass + '">';
              html += '<input class="color-swatch__radio visually-hidden" type="radio" name="' + boostPFSThemeConfig.custom.template_id + '-{{itemId}}" id="' + boostPFSThemeConfig.custom.template_id + '-{{itemId}}-' + (i + 1) + '" value="' + Utils.escape(color) + '" ' + (i == 0 ? 'checked="checked"' : '') + ' data-variant-id="' + variant.id +'" ' + (variantImageId != '' ? 'data-variant-featured-media="' + variantImageId +'"' : '') +'>';
              html += '<label class="color-swatch__item" for="' + boostPFSThemeConfig.custom.template_id + '-{{itemId}}-' + (i + 1) + '" style="' + colorSwatchStyle + '">';
              html += '<span class="visually-hidden">' + color + '</span>';
              html += '</label>';
              html += '</div>';
            }else if (variant.available){
              extras++;
            }
          }
          if(extras > 0){
             html += '<span class="boost-pfs-filter-item-swatch-more"> + '+extras+'</span>';
            
          }
          html += '</div>';
        }
      }
      return html;
    }

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1)).replace(/{{itemTitle}}/g, currentPage - 1);
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1)).replace(/{{itemTitle}}/g, currentPage + 1);
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]).replace(/{{page}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'checked="checked"'
					}
                  	sortingItemsHtml += '<label class="popover__choice-item">';
                    sortingItemsHtml += '<input type="radio" data-bind-value="sort-by-selected-value" class="visually-hidden" ' + isSelected + ' name="sort_by" value="' + k + '" title="' + sortingArr[k] + '">';
                    sortingItemsHtml += '<span class="popover__choice-label">' + sortingArr[k] + '</span>';
                    sortingItemsHtml += '</label>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ('.popover__choice-item').on('click', function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).find('input').val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	};

  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
      
      	
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
      
      	var totalProduct = '';
      	if (data.total_product > 1) {
          totalProduct = boostPFSThemeConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
        } else {
          totalProduct = boostPFSThemeConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
        }
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
      
      	jQ('.product-item[reveal]').css('opacity', 1);
	};

	/************************** END BUILD TOOLBAR **************************/
  
  	SearchResultPanelItem.prototype.compileTemplate = function() {
		return this.getTemplate()
			.replace(/{{panelItemLabel}}/g, Utils.stripHtml(this.data.label))
			.replace(/{{panelItemCount}}/g, Utils.stripHtml(this.totalResult))
			.replace(/{{class.searchResultPanelItem}}/g, Class.searchResultPanelItem + ' tabs-nav__item heading heading--small');
	}
})();
